import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Protege las rutas /admin/*: exige token de admin.
// Si no hay sesión de admin, redirige a /admin/login (no a /).
const AdminRoute = () => {
  const adminAuth = useSelector(state => state.adminAuth);
  return adminAuth.token ? <Outlet /> : <Navigate to="/admin/login" />;
};

export default AdminRoute;
